/* global API */
import toArray from '../helpers/toArray';
import formatPrice from '../helpers/formatPrice';

const $countrySelector = $('.js-country-select');
const $otherAddressCheckbox = $('.js-delivery-address-check');
const $shippingMethodsOutput = $('.js-shipping-methods-output');
const $pickupLocationAlert = $('.js-pickup-location-alert');
const $countrySelect = $('.js-country-select');
const $shippingCountrySelect = $('.js-shipping-country-select');
const $summaryDelivery = $('.js-summary-delivery');
const $summarySubtotal = $('.js-summary-subtotal');
const $summaryDiscount = $('.js-summary-discount');
const $summaryTotal = $('.js-summary-total');

const shippingForCountry = {
  initialize() {
    if (!$countrySelector.length) return;

    this.selectedShippingMethodId = null;

    this.createListeners();
  },

  createListeners() {
    let defaultCountryId = 1;

    if ($countrySelect.length) {
      defaultCountryId = $countrySelect.val();
    }

    if ($otherAddressCheckbox.length && $otherAddressCheckbox[0].checked) {
      defaultCountryId = $shippingCountrySelect.val();
    }

    this.getShippingMethods(defaultCountryId);

    $('.js-data').on('change', '.js-shipping-selector', (e) => {
      this.selectedShippingMethodId = e.currentTarget.dataset.id;

      this.showSummaryShippingCosts();
    });

    $('.js-data').on('change', '.js-country-select, .js-shipping-country-select', (e) => {
      let select = $countrySelector;

      if ($otherAddressCheckbox[0].checked && $(e.currentTarget).hasClass('js-country-select')) {
        return;
      }

      if ($otherAddressCheckbox[0].checked) {
        select = $('.js-shipping-country-select');
      }

      const value = select.val();

      this.getShippingMethods(value).then(() => {
        const shippingMethods = toArray(document.querySelectorAll('.js-shipping-selector'));

        if (!this.selectedShippingMethodId) {
          this.selectedShippingMethodId = shippingMethods[0].dataset.id;

          this.showSummaryShippingCosts();
        }

        // eslint-disable-next-line
        let selectedShippingMethod = shippingMethods.find((method) => {
          return method.dataset.id === this.selectedShippingMethodId;
        });

        // Check if we couldn't find any selectedShippingMethod. We can get the first shippingMethod
        if (!selectedShippingMethod) {
          this.selectedShippingMethodId = shippingMethods[0].dataset.id;

          selectedShippingMethod = shippingMethods
            .find((method) => method.dataset.id === this.selectedShippingMethodId);
        }

        selectedShippingMethod.checked = true;

        const subtotal = parseFloat($summarySubtotal.data('subtotal-costs'));
        const discount = $summaryDiscount?.data('summary-discount') ?? 0;
        const shippingCosts = parseFloat(selectedShippingMethod.dataset.shippingCosts);

        $summaryDelivery.html(formatPrice(shippingCosts));
        $summaryTotal.html(formatPrice((subtotal + shippingCosts) - discount));
      });
    });
  },

  getShippingMethods(country) {
    return $.ajax({
      url: API.shippingMethods,
      type: 'GET',
      data: {
        country,
      },
      success: (res) => {
        if (!res.shippingMethodsView) {
          return;
        }

        $pickupLocationAlert.toggle(res.hasMyParcel);

        this.outputShippingMethods(res.shippingMethodsView);
      },
    });
  },

  outputShippingMethods(shippingMethods) {
    $shippingMethodsOutput.html($(shippingMethods));
  },

  showSummaryShippingCosts() {
    if (!$summaryDelivery.length) {
      return;
    }

    $summaryDelivery.closest('tr').show();
  },
};

export default shippingForCountry;
